<template>
    <div v-if="isURL || isLongText" class="d-flex align-items-center">
        <a v-if="isURL" :href="text" target="_blank" class="text-truncate">{{ text }}</a>
        <div v-else class="text-truncate">{{ text }}</div>
        <Icon name='copy' class="c18 ml8 pointer" @click="copy(text)"/>
    </div>
    <div v-else-if="isSum" class="d-flex align-items-center">
        <div class="neue text-truncate" :class="{ 'fsp14': isMobile, 'fsp16 lh24': !isMobile }">
            <span>
                <span class="neue">{{ text.split('.')[0] }}</span>
                <span class="primary-grey" :class="{ 'fsp10': isMobile, 'fsp12': !isMobile }">.{{ sumHasTicker() ? text.split('.')[1].split(' ')[0] : text.split('.')[1] }}</span>
            </span>&nbsp;
        </div>
        <div v-if="sumHasTicker()" class="neue primary-grey text-truncate lh16" :class="{ 'fsp14': isMobile, 'fsp16': !isMobile }">{{ sumHasTicker() }}</div>
    </div>
    <div v-else>{{ text }}</div>
</template>

<script>
import Icon from '@/components/icons/Icon';

export default {
    name: 'Text',
    components: {
        Icon
    },
    props: {
        text: {
            type: String,
            required: true
        },
        isSum: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        sumHasTicker() {
            return this.text.split(' ')[1]
        },
        copy(text) {
            this.$lib.copyTextS(text, this.$store)
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        isLongText() {
            return /^[^\s.]{25,}$/.test(this.text);
        },
        isURL() {
            try {
                new URL(this.text);
                return true;
            } catch (error) {
                return false;
            }
        }
    }
}
</script>